import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HomeoutRoutingModule } from './homeout-routing.module';
import { OfferComponent } from './offer/offer.component';
import { OfferViewComponent } from './offer-view/offer-view.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule, MatDatepickerModule, MatSelectModule } from '@angular/material';
import { MaterialModule } from '../route-file/material.module';


@NgModule({
  declarations: [OfferComponent,OfferViewComponent],
  imports: [
    CommonModule,
    HomeoutRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    MatSelectModule,
    MaterialModule,
    MatDatepickerModule
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class HomeoutModule { }
